<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> Muhasebe Yekun Kontrolü </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
            <v-form ref="muhasebehesabagore" v-model="valid">
              <v-layout row wrap="">
                <v-flex xs12 sm12 md3>
                  <catimuhasebekodu
                    v-model="accoutingCode"
                    :controlValue="accoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="'Muhasebe Kodu'"
                    @validateCheck="checkAccoutingValidate()"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
              <v-checkbox v-model=searchParams.ExcludeClosingFiche
      label="Kapanış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-checkbox v-model=searchParams.ExcludeOpeningFiche
      label="Açılış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
            </v-flex>
                <v-flex>
                  <v-layout>
                    <v-btn color="info" @click="getList()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout>
              <v-flex xs12 sm12 md12 pt-2>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    class="elevation-1"
                    :rows-per-page-items="[50, 100]"
                    :items="items"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">
                        {{ props.item.Mounth }}
                      </td>

                      <td class="text-xs-left">
                        {{ props.item.RecieptDebit | moneyformat }}
                      </td>

                      <td class="text-xs-right">
                        {{ props.item.RecieptCredit | moneyformat }}
                      </td>

                      <td class="text-xs-right">
                        {{ CheckBalance(props.item.RecieptBalance) | moneyformat }}
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      search: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      searchParams: {
        CompanyID: 0,
        FirstDate: null,
        EndDate: null,
        FirstAccountCode: null,
        EndAccountCode: null,
        ExcludeClosingFiche:0,
        ExcludeOpeningFiche:0
      },
      accoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      itemDetails: [],
      headers: [
        {
          text: "Ay",
          align: "left",
        },
        {
          text: "Borç",
          align: "left",
        },
        {
          text: "Alacak",
          align: "right",
        },
        {
          text: "Bakiye",
          align: "right",
        },
      ],
      TotalCredit: 0,
      TotalCreditBalance: 0,
      TotalDept: 0,
      TotalDeptBalance: 0,
    };
  },
  mounted() {
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
      if (this.sayfayetki.Status == true) {
        //YETKİ OK
      } else {
        this.$refs.yetkidialog
          .open(this.sayfayetki.Message, this.sayfayetki.islem)
          .then((sonuc) => {
            if (sonuc == true) {
              if (this.prevRoute != null) {
                var url = "#" + this.prevRoute;
  
                window.open(url, "_self");
              } else {
                var mainUrl = "#/";
                window.open(mainUrl, "_self");
              }
            }
          });
      }
    },
  methods: {
    CheckBalance(val) {
      if (val > 0) {
        return this.moneyformat(val) + " B";
      } else if (val == 0) {
        return this.moneyformat(val);
      } else {
        return this.moneyformat(val * -1) + " A";
      }
    },
    checkAccoutingValidate() {
      this.accoutingCode.CodeID = 0;
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    getList() {
      this.items = [];
      this.loadingvmodel = true;
      let params = {
        AccountingCodeID: this.accoutingCode.CodeID,
        CompanyID: this.credentials.MuhasebeSirketNo,
        ExcludeClosingFiche :this.searchParams.ExcludeClosingFiche,
        ExcludeOpeningFiche: this.searchParams.ExcludeOpeningFiche,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/TrialBalanceControlList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.DetailList.length > -1) {
              this.items = response.body.DetailList;
              this.loadingvmodel = false;
            } else {
              this.text1 = this.$t("No-Records-Found");
              this.snackbar = true;
              this.items = [];
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getListHtml() {
      this.loadingvmodel = true;
      let params = {
        CodeID: this.accoutingCode.CodeID,
        CompanyID: this.credentials.MuhasebeSirketNo,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/TrialBalanceControlListHtml",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/html",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeMizanYekun.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },

    getListExcel() {
      this.items = [];
     this.loadingvmodel = true;
      let params = {
        CodeID: this.accoutingCode.CodeID,
        CompanyID: this.credentials.MuhasebeSirketNo,
        ExcludeClosingFiche :this.searchParams.ExcludeClosingFiche,
        ExcludeOpeningFiche: this.searchParams.ExcludeOpeningFiche,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/TrialBalanceControlListExcel",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeMizanYekun.xlsx";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
  },
};
</script>

<style>
</style>

